
















































import { Vue, Component } from 'vue-property-decorator'
import {
  MainHead,
  HeadTabs,
  WingBlank,
  PlanRunStatusAll,
} from '@/components/index'
import DetailHeadTitle from './components/DetailHeadTitle/index.vue'

import { PlanPageDetail, PlanDetail, PlanEnable, PlanDisable } from '@/api/plainAdmin'
import { PlanPageDetailForm, PaginationForm } from '@/types/PlanAdmin'
import { NBMessageBox } from '@/utils/nBMessageBox'
@Component({
  components: {
    MainHead,
    HeadTabs,
    WingBlank,
    PlanRunStatusAll,
    DetailHeadTitle,
  },
})
export default class PlainningDetail extends Vue {
  // 头部数据
  headData: string[] = [
    '创建并维护各对象的分群，并对分群中的对象实例进行分析。',
  ];
  headTitle: string = '运营计划名称';
  // btnText1: '停用计划';
  // btnText2: '编辑';
  /**
   * datailHead 详情头部数据
   *
   */
  datailHead: any = {};

  /**
   * 表格 分页
   * paginationObj
   * table
   */
  paginationObj: PaginationForm = {
    current: 0,
    size: 10,
  };
  // 表格数据
  table: any = {};
  handleSizeChange(val: number) {
    this.paginationObj.size = val
    this.getCategoDetail()
  }
  handleCurrentChange(val: number) {
    this.paginationObj.current = val - 1
    this.getCategoDetail()
  }
  // 查看详情
  handleCatDetail(val: any) {
    // 跳转到 计划日志页面
    const { datailHead } = this
    const _form: any = {
      // datailHead.objectId
      objectId: datailHead.objectId,
      planId: val.planId,
      executeTime: val.executeTime,
    }
    this.$router.push({
      path: '/operate/log',
      query: {
        _form,
      },
    })
  }
  created() {
    this.getCategoDetail()
  }
  async getCategoDetail() {
    const { id } = (this as any).$route.query
    const { data } = await PlanDetail(id)

    const params:PlanPageDetailForm = { planId: id, ...this.paginationObj }
    var { data: dataPage } = await PlanPageDetail(params)

    this.datailHead = data

    this.table = dataPage
    this.datailHead.total = dataPage.total
  }
  /**
   * 停用、启用计划
   * handeleBtnText1
   */
  async handeleBtnText1() {
    const { datailHead } = this
    const { status, id } = datailHead
    if (status === 1) {
      // 禁用

      try {
        const { msg } = await NBMessageBox(this)
        await PlanDisable(id)

        msg()
        this.getCategoDetail()
      } catch (e) {
        e.msg()
      }
    } else if (status === 4) {
      // 启用

      try {
        const { msg } = await NBMessageBox(this)
        await PlanEnable(id)
        msg()
        this.getCategoDetail()
      } catch (e) {
        e.msg()
      }
    }
  }
  /**
   * 编辑
   * handeleBtnText2
   */
  handeleBtnText2() {
    const { datailHead } = this
    this.$router.push({
      path: '/operate/create',
      query: {
        objectId: datailHead.objectId,
        objectName: this.$route.query.objectName,
        formObj: datailHead,
        type: 'edit'
      }
    })
  }
}
